import { ADD_SEGMENT_MODAL_OPEN_STATUS } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (isOpen) => (dispatch) => {
    dispatch(panelLayoutV2Actions[ADD_SEGMENT_MODAL_OPEN_STATUS](isOpen));
};
